import { userPreferencesApiConnector } from 'apiConnector/userPreferences/userPreferences';
import { ofType } from 'redux-observable';
import type { Observable, SchedulerLike } from 'rxjs';
import { of } from 'rxjs';
import { catchError, map, switchMap, timeoutWith } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import {
  userPreferencesFailed,
  userPreferencesReceived,
  userPreferencesTimeouted,
} from 'state/userPreferences/userPreferences.action';
import type { UserPreferences } from 'state/userPreferences/userPreferences.model';
import { extractHttpErrorMessage, type HttpClientError } from 'utils/http/httpClient.model';

export interface FetchUserPreferencesEpicApi {
  fetchUserPreferences(): Observable<UserPreferences>;
}

export function fetchUserPreferencesEpic(appScheduler?: SchedulerLike): EpicWithThunk {
  return (actions$, _state$, { httpClient, getSgmeConfiguration }) =>
    actions$.pipe(
      ofType('USER_PREFERENCES_REQUESTED'),
      switchMap(() => {
        return userPreferencesApiConnector(httpClient)
          .fetchUserPreferences()
          .pipe(
            map(result => userPreferencesReceived(result)),
            catchError((err: HttpClientError) => of(userPreferencesFailed(extractHttpErrorMessage(err)))),
            timeoutWith(
              getSgmeConfiguration()?.userPrefsTimeoutMs || 5000,
              of(userPreferencesTimeouted()),
              appScheduler,
            ),
          );
      }),
    );
}
